// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@awc/XDL/Utilities";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useMemo } from "react";

interface OwnProps {
    extendedStyles?: ProductLeadTimeStyles;
}

type Props = OwnProps & HasProduct;

export interface ProductLeadTimeStyles {
    text?: TypographyPresentationProps;
}

export const productLeadTimeStyles: ProductLeadTimeStyles = {};

const ProductLeadTime: FC<Props> = ({ product, productInfo, extendedStyles }) => {
    const styles = useMemo(() => mergeWithCss(productLeadTimeStyles, extendedStyles), []);

    if (!productInfo.pricing?.additionalResults) {
        return null;
    }

    const availableQuantity = +productInfo.pricing.additionalResults["availableQuantity"];
	const displayQuantity = productInfo.pricing.additionalResults["displayQuantity"];
    const leadTime = +productInfo.pricing.additionalResults["leadTime"];
    const isStocked = productInfo.pricing.additionalResults["isStocked"];
	
	
	if (availableQuantity > 0) {
        return (
            <Typography {...styles.text} data-test-selector="ProductLeadTime">
                {`${siteMessage("Custom_Available_Qty_Text", "Available QTY")}: ${displayQuantity}`}
            </Typography>
        );
    }
	
	if (
		isStocked === "true" ||
		(!product.quoteRequired && productInfo.pricing.unitNetPrice !== 0) 
		&& (leadTime <= 0 || Number.isNaN(leadTime))){
		return(
		   <Typography {...styles.text} data-test-selector="ProductLeadTime">
				{`${siteMessage("Inventory_AvailableStock", "In Stock")}`}
			</Typography>
		);
	}
    if (
        product.quoteRequired ||
        productInfo.pricing.unitNetPrice === 0 ||
        (availableQuantity <= 0 && (leadTime <= 0 || Number.isNaN(leadTime)))
    ) {
        return (
            <Typography {...styles.text} data-test-selector="ProductLeadTime">
                {siteMessage("Custom_Quote_Only_Text", "Quote Only")}
            </Typography>
        );
    }

    return (
        <Typography {...styles.text} data-test-selector="ProductLeadTime">
            {`${siteMessage("Custom_Lead_Time_Text", "In Stock")}: ${leadTime} ${translate("days")}`}
        </Typography>
    );
};

export default withProduct(ProductLeadTime);
